import { Component } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AutenticationService } from './services/autentication.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  exibMenuSair: boolean

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private alertCtrl: AlertController,
    private autenticacao: AutenticationService
  ) {
    this.initializeApp();
    this.verificarUsuario();

  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  verificarUsuario() {
    const user = JSON.parse(localStorage.getItem('data'));
    if (user) {
      this.exibMenuSair = true;
    }
    else {
      this.exibMenuSair = false;
    }
  }

  sair() {

    this.autenticacao.logout();
    this.exibMenuSair = false;

  }

 public  hiddenSair(): boolean{
    if(JSON.parse(localStorage.getItem('data')))
    return false;
 
    return true;
  }


  async alertSuporte() {
    const confirm = await this.alertCtrl.create({

      header: 'Suporte',
      cssClass: 'alertSuporte',
      message: '<table>' +
               '<tr>' +  
               '<td> <img src="../../../assets/img/whatsapp.png"> </td>' + 
               '<td> <a target="_blank" href="https://wa.me/5581999955388"> (81) 99995-5388 </a> </td>' +
               '</tr>' +
               '</table>',
      
      buttons: [
        {
          text: 'Ok',
          handler: () => {

          }
        }
      ]
    });

    await confirm.present();
  }


}
